/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

// ========= modules component import section ========= //
import { IconContext } from 'react-icons';
import { MdSettings } from 'react-icons/md';
import moreIcon from '../../../images/more.png';
import * as _ from 'lodash';
import ReactLoading from 'react-loading';
// ====== end of modules component import section ====== //

// ========= project component import section ========= //
import TableHeader from '../components/TableHeader';
// ====== end of project component import section ====== //

// ========= action import section ========= //
// ====== end of action import section ====== //

// ========= interface import section ========= //
import { BidInterface } from '../../../interface/bid';
import DataHistoryInterface from '../../../interface/reducers/history';
import {
  _NEW,
  ON_COURIER,
  _SELLER_SENT,
  _ON_CANCEL,
  _KA_RECEIVED,
  _VERIFIED_PASS,
  _VERIFIED_FAIL,
  _SENT_BUYER,
  _DONE_BY_BUYER,
  ON_DONE,
  _DONE_BY_ADMIN,
  _DONE_BY_CRON,
  UNDER_REVIEW,
  ADMINISTRATOR,
  remaining_time,
  _PENDING_PAYMENT,
  _VERIFYING_BID,
  EXPIRED,
  _VERIYING_PAYMENT,
  _COMPLETED,
  _PENDING_REFUND,
  _REFUNDED,
  convertToRupiah,
  AKULAKU,
  ATOME,
  GOPAY,
  KREDIVO,
} from '../../../utils';
import ModalPending from '../components/ModalPending';
import { ShippingInterface } from '../../../interface/shipping';
import ModalPaymentConfirmation from '../../Modals/ModalPaymentConfirmation';
import {
  MANDIRI_CREDIT_CARD,
  MANDIRI_DEBIT_CARD,
  CREDITCARD,
  INSTALLMENTS,
  BCA_INSTALLMENTS,
  BANKTRANSFER,
  MANDIRI_VA,
  BCA_VA,
  PERMATA_VA,
  BNI_VA,
  BRI_VA,
  VIRTUALACCOUNT,
  FULLWALLET,
  BCA_CREDIT_CARD,
  BNI_CREDIT_CARD,
  BNI_DEBIT_CARD,
  BCA_KLIK_PAY,
  BCA_ONEKLIK,
} from '../../../constants/paymentMethods';
import DataPaymentInterface, {
  DetailMidtransInterface,
} from '../../../interface/reducers/payment';
import { doGetMidtransPaymentDetail } from '../../../actions/paymentAction';
// ====== end of interface import section ====== //

const moreIconNew: any = moreIcon;

type stateToProps = {
  dataHistory: DataHistoryInterface;
  dataPayment: DataPaymentInterface;
  dataAuth: AuthInterface;
};

interface PendingInterface extends stateToProps {
  callbackAfterUpdate: () => any;
  getMidtransDetail: (invoice: string) => Promise<any>;
  dataMidtrans: DetailMidtransInterface;
  loading: boolean;
  userCurrency: UserCurrencyInterface;
}

const _isSnapSupported = () => {
  const snap = 'snap' in window;
  return snap !== undefined;
};

import EMPTY_STATE from '../../../images/dashboard-empty-state.jpg';
import {
  accessoriesCondition,
  boxCondition,
  boxHandbag,
  displayItem,
  dustBag,
  formatCurrency,
  handleImageCategory,
  handbagCondition,
  sneakersCondition,
  sneakersDefect,
  yellowing,
  sneakerDefectsCondition,
} from '../../../utils/Helpers';
import AuthInterface, {
  UserCurrencyInterface,
} from '../../../interface/reducers/auth';

const handlePaymentMethodText = (item: string, via?: string) => {
  let firstText = '';
  let secondtext = '';

  switch (item.toLocaleLowerCase()) {
    case MANDIRI_CREDIT_CARD:
      firstText = 'MANDIRI Credit Card';
      secondtext = '';
      break;
    case MANDIRI_DEBIT_CARD:
      firstText = 'MANDIRI Debit Card';
      secondtext = '';
      break;
    case CREDITCARD:
    case INSTALLMENTS:
      firstText = '';
      secondtext = 'Credit / Debit Card';
      break;
    case BCA_INSTALLMENTS:
      firstText = 'BCA Installments';
      secondtext = '';
      break;
    case BANKTRANSFER:
      firstText = 'Bank Transfer';
      secondtext = '';
      break;
    case MANDIRI_VA:
      firstText = 'MANDIRI';
      secondtext = 'Virtual Account';
      break;
    case BCA_VA:
      firstText = 'BCA';
      secondtext = 'Virtual Account';
      break;
    case PERMATA_VA:
      firstText = 'PERMATA';
      secondtext = 'Virtual Account';
      break;
    case BNI_VA:
      firstText = 'BNI';
      secondtext = 'Virtual Account';
      break;
    case BRI_VA:
      firstText = 'BRI';
      secondtext = 'Virtual Account';
      break;
    case GOPAY:
      firstText = 'GOPAY';
      secondtext = '';
      break;
    case VIRTUALACCOUNT:
      if (via === 'xnd') {
        firstText = 'Other';
        secondtext = 'Virtual Account';
      } else {
        firstText = 'BCA';
        secondtext = 'Virtual Account';
      }
      break;
    case FULLWALLET:
      firstText = 'Kick Credit';
      secondtext = '';
      break;
    case BCA_CREDIT_CARD:
      firstText = 'BCA Credit Card / Debit Card';
      secondtext = '';
      break;
    case BNI_CREDIT_CARD:
      firstText = 'BNI Credit Card';
      secondtext = '';
      break;
    case BNI_DEBIT_CARD:
      firstText = 'BNI Debit Card';
      secondtext = '';
      break;
    case KREDIVO[0]:
      firstText = 'Kredivo';
      secondtext = '';
      break;
    case ATOME[0]:
      firstText = 'Atome';
      secondtext = '';
      break;
    case AKULAKU[0]:
      firstText = 'Akulaku';
      secondtext = '';
      break;
    case BCA_KLIK_PAY:
      firstText = 'BCA';
      secondtext = 'Klik Play';
      break;
    case BCA_ONEKLIK:
      firstText = 'BCA';
      secondtext = 'One Klik';
      break;
    default:
      firstText = '';
      secondtext = '';
      break;
  }
  return secondtext + ' ' + firstText;
};

const _sellerToBuyer = ({
  status,
  seller_responded,
  ka_sent,
  seller_awb_number,
}: any) => {
  switch (status) {
    case _NEW[0]:
      return seller_responded ? ON_COURIER[3] : _NEW[2];
    case _SELLER_SENT[0]:
      return seller_awb_number ? _SELLER_SENT[2] : ON_COURIER[3];
    case _ON_CANCEL[0]:
      return _ON_CANCEL[2];
    case _KA_RECEIVED[0]:
      return _KA_RECEIVED[1];
    case _VERIFIED_PASS[0]:
      return _VERIFIED_PASS[2];
    case _VERIFIED_FAIL[0]:
      return _VERIFIED_FAIL[2];
    case _SENT_BUYER[0]:
      return ka_sent ? _SENT_BUYER[2] : 'Awaiting shipment';
    case _DONE_BY_BUYER:
      return ON_DONE[1];
    case _DONE_BY_ADMIN:
      return ON_DONE[1];
    case _DONE_BY_CRON:
      return ON_DONE[1];
    case UNDER_REVIEW[0].toUpperCase():
      return UNDER_REVIEW[1];
    default:
      return ADMINISTRATOR[1];
  }
};

const _getStatusPurchase = ({ sale, status, expiry }: any) => {
  if (
    remaining_time(expiry).distance < 0 &&
    (status === _PENDING_PAYMENT[0] || status === _VERIFYING_BID[0])
  ) {
    return EXPIRED[2];
  }

  switch (status) {
    case _PENDING_PAYMENT[0]:
      return _PENDING_PAYMENT[2];
    case _VERIYING_PAYMENT[0]:
      return _VERIYING_PAYMENT[2];
    case _COMPLETED:
      return _sellerToBuyer(sale[0]);
    case ON_COURIER:
      return ON_COURIER[1];
    case ON_DONE:
      return ON_DONE[1];
    case _ON_CANCEL[0]:
      return _ON_CANCEL[2];
    case _PENDING_REFUND[0]:
      return _PENDING_REFUND[2];
    case _REFUNDED[0]:
      return _REFUNDED[2];
    case EXPIRED[0]:
      return EXPIRED[2];
    case _VERIFYING_BID[0]:
      return _VERIFYING_BID[2];
    default:
      return ADMINISTRATOR[1];
  }
};

export interface PendingDetailData {
  brandName: string;
  displayName: string;
  SKU: string;
  size: number;
  paymentMethod: string;
  imageUrl: string;
  boxCondition: any;
  displayItem: any;
  missingAccessories: any;
  sneakersCondition: any;
  sneakersDefect: any;
  yellowing: boolean;
  totalAmount: number;
  expiryDate: string;
  streetAddress: string;
  category: string;
  defects: any;
  status: string;
  bankCode: any;
  invoiceNumber: string;
  invoiceUrl: string;
  paymentVia: string;
  totalAdjustedAmount: string;
  saleStatus: string;
  buyingPrice: string;
  expired: string;
  purchasedDate: string;
  shippingCourier: string;
  AWB: string;
  hideBoxInfo: boolean;
  isVintage: boolean;
  shipping: ShippingInterface;
}

/**
 * Pending tab on Buying User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {PendingInterface} props for this component.
 * @return {JSX.Element}
 */
function PendingTab({
  dataHistory,
  callbackAfterUpdate,
  dataMidtrans,
  dataPayment,
  getMidtransDetail,
  loading,
  userCurrency,
}: PendingInterface): JSX.Element {
  const [isOpenedModalPending, setOpenedModalPending] = useState(false);
  const [isOpenedModalSnap, setOpenedModalSnap] = useState(false);
  const [pendingDetailData, setPendingDetailData] = useState<
    PendingDetailData | {}
  >({});

  useEffect(() => {
    if (isOpenedModalSnap) {
      if (_isSnapSupported()) {
        window.snap.pay(dataMidtrans.data.transaction_token, {
          onSuccess: (r: any) => {
            window.location = r.finish_redirect_url;
            setOpenedModalSnap(false);
          },
          onPending: () => {
            setOpenedModalSnap(false);
          },
          onError: () => {
            setOpenedModalSnap(false);
          },
          onClose: () => {
            setOpenedModalSnap(false);
          },
          language: 'en',
        });
      } else {
        window.location = `/invoices/${dataPayment.payments.data.invoice_number}?trx_id=${dataPayment.payments.data.payment_gateway.transaction_token}`;
      }
    }
  }, [dataMidtrans.data, isOpenedModalSnap]);

  const [isModalConfirmationOpened, setModalConfirmationOpened] = useState(
    false,
  );
  const [paymentInfo, setPaymentInfo] = useState({
    invoiceNumber: '',
    transferAmount: 0,
  });
  const toggleModalConfirmation = () => {
    setModalConfirmationOpened(!isModalConfirmationOpened);
  };

  useEffect(() => {
    if (!isOpenedModalPending) setPendingDetailData({});
  }, [isOpenedModalPending]);

  const toggleModalPending = () => setOpenedModalPending(!isOpenedModalPending);
  const callback = () => {
    callbackAfterUpdate();
    toggleModalConfirmation();
  };

  /**
   * Table item for Pending List in Buying Dashboard
   * @param {BidInterface} item
   * @return {JSX.Element}
   */
  function renderItemPending(item: BidInterface): JSX.Element {
    const isDefects = item?.user_sell?.defects.length > 0;
    const category = item.user_sell.product_variant.product.category.name;
    const uniqueDefects = _.uniqBy(
      isDefects ? item.user_sell.defects : null,
      'name',
    );
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'DUST_BAG' && a.value)
      : {};
    const isVintage = item.user_sell.product_variant.vintage;
    const hideBoxInfo = item.user_sell.product_variant.hide_box_info;
    const sneakersDetailArr = [
      isVintage
        ? 'Vintage'
        : sneakersCondition(item.user_sell.sneakers_condition),
      hideBoxInfo ? '' : boxCondition(item.user_sell.box_condition),
      accessoriesCondition(item.user_sell.missing_accessories),
      yellowing(item.user_sell.yellowing),
      displayItem(item.user_sell.display_item),
      sneakersDefect(item.user_sell.sneakers_defect),
      isDefects ? sneakerDefectsCondition(uniqueDefects) : '',
    ];
    const sneakersDetail = sneakersDetailArr
      .filter((item) => item !== '')
      .map((item) => item)
      .join(' / ');
    const luxuryDetailArr = [
      sneakersCondition(item.user_sell.sneakers_condition),
      hideBoxInfo ? '' : boxCondition(item.user_sell.box_condition),
      accessoriesCondition(item.user_sell.missing_accessories),
      dustBag(dustBagCondition),
      isDefects ? handbagCondition(uniqueDefects) : '',
    ];
    const luxuryDetail = luxuryDetailArr
      .filter((item) => item !== '' && item !== 'Missing Box')
      .map((item) => item)
      .join(' / ');

    const isBcaCard = item.payment_via === "spa" && item.payment_type === 'credit_card';

    const isTicket = item.user_sell.product_variant.product.name.includes('Ticket');

    const clickedDetail = () => {
      setPendingDetailData({
        brandName:
          category === 'lifestyles'
            ? item.user_sell.product_variant.product.brand.name
            : item.user_sell.product_variant.product.brand.flat[0],
        displayName: item.user_sell.product_variant.display_name,
        SKU: item.user_sell.product_variant.SKU,
        size: item.user_sell.size.US,
        paymentMethod: item.payment_via === 'spa' ? item.payment_type : item.payment_method_request || item.payment_method,
        imageUrl: item.user_sell.product_variant.product_variant_images.length
          ? item.user_sell.product_variant.product_variant_images[0].URL
          : '',
        boxCondition: item.user_sell.box_condition,
        displayItem: item.user_sell.display_item,
        missingAccessories: item.user_sell.missing_accessories,
        sneakersCondition: item.user_sell.sneakers_condition,
        sneakersDefect: item.user_sell.sneakers_defect,
        yellowing: item.user_sell.yellowing,
        totalAmount: item.actual_total_amount,
        expiryDate: item.expired_at,
        streetAddress: item.shipping.street_address,
        category,
        defects: item.user_sell.defects,
        status: item.status,
        bankCode: item.bank_code,
        invoiceNumber: item.invoice_number,
        invoiceUrl: item.invoice_url,
        paymentVia: item.payment_via,
        totalAdjustedAmount: item.total_adjusted_amount,
        saleStatus:
          _getStatusPurchase(item) === _VERIFIED_FAIL[2]
            ? _VERIFIED_FAIL[3]
            : _getStatusPurchase(item),
        buyingPrice: item.total_amount,
        expired: item.expired,
        purchasedDate: item.sale.length ? item.sale[0].customer_paid : '-',
        shippingCourier: item.sale.length
          ? item.sale[0].sale_shipping.ka_courier
          : '-',
        AWB: item.sale.length ? item.sale[0].sale_shipping.awb_number : '-',
        hideBoxInfo: item.user_sell.product_variant.hide_box_info,
        isVintage: item.user_sell.product_variant.vintage,
        shipping: item.shipping,
        kickPoints: item.lbalance_amount,
        sellerCredit: item.scredit_amount,
        kickCredit: item.wallet_amount,
        isBcaCard,
        isTicket,
      });
      toggleModalPending();
    };

    const clickedConfirm = () => {
      if (item.payment_via === 'xnd' || item.payment_via === 'spa' || item.payment_method === 'kredivo' || item.payment_method === 'atome' || item.payment_method === 'akulaku') {
        window.open(item.invoice_url);
      } else if (item.payment_method === 'bank_transfer') {
        setPaymentInfo({
          invoiceNumber: item.invoice_number,
          transferAmount: parseInt(item.total_adjusted_amount),
        });
        toggleModalConfirmation();
      } else {
        getMidtransDetail(item.invoice_number).then(() => {
          setOpenedModalSnap(true);
        });
      }
    };

    return (
      <div className={'item-table'}>
        <div className={'product-container'}>
          <KickImage
             src={handleImageCategory(isTicket, category.toLowerCase())}
            className={'image-category'}
          />
          <div>
            <p className={'title'}>
              {item?.user_sell?.product_variant?.display_name}
            </p>
            {category === 'handbags' ||
            (category === 'lifestyles' &&
              item?.user_sell.size?.US.toLowerCase() !== 'all size') ? (
              <div className={'size'}>
                <p>{item?.user_sell.size?.US}</p>
              </div>
            ) : (
              <div className={'size'}>
                <p>US {item?.user_sell.size?.US}</p>
              </div>
            )}
            {
              isTicket ? 
              <p className={'condition'}>{sneakersCondition(item.user_sell.sneakers_condition)}</p> :
              <p className={'condition'}>
                {item.user_sell.product_variant.product.category.name !==
                'handbags'
                  ? sneakersDetail
                  : luxuryDetail}
              </p>
            }
            <p className={'extra'}>
              {item?.user_sell?.product_variant?.colour}
            </p>
            {
              item.user_sell.pre_order? 
              <div className={'pre-order-wrapper'}>
                <p className={'pre-order'}>Pre-Order</p>
              </div> : null
            }
          </div>
        </div>
        <div className={'status-container'}>
          <div className={'price-container'}>
            <p className={'status-text'}>{_getStatusPurchase(item)}</p>
            <p className={'payment-method-text'}>
              {_getStatusPurchase(item) === 'Awaiting Payment'
                ? isBcaCard ? "BCA Card" : 
                  handlePaymentMethodText(item.payment_via === 'spa' ? item.payment_type || item.payment_method : item.payment_method_request || item.payment_method, item.payment_via)
                : null}
            </p>
            <span>
              {formatCurrency(
                item.total_adjusted_amount,
                userCurrency.ratio,
                userCurrency.currency,
              )}
            </span>
          </div>
          <div className={'button-container'}>
            {_getStatusPurchase(item) === 'Awaiting Payment' ? (
              <div className={'button'} onClick={clickedConfirm}>
                Complete Payment
              </div>
            ) : (
              <div className={'button no-bg'} />
            )}
          </div>
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div className={'icon-container'} onClick={clickedDetail}>
              {/* <MdSettings /> */}
              <KickImage src={moreIconNew} alt="..." />
            </div>
          </IconContext.Provider>
        </div>
      </div>
    );
  }

  /**
   * Rendering Empty State UI
   * @return {JSX.Element}
   */
  function renderEmpty() {
    return (
      <div className={'empty-container'}>
        <KickImage src={EMPTY_STATE} />
        <p>It seems you haven’t got anything on purchasing.</p>
        <div className={'button-refresh'} onClick={callbackAfterUpdate}>
          <p>Refresh</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <TableHeader
        getData={callbackAfterUpdate}
        type={'pending'}
        mode={'buying'}
      />
      <div className={'table-container'}>
        <div className={'header-table'}>
          <div className={'product-container'}>
            <span>Product</span>
          </div>
          <div className={'status-container'}>
            <span>Status</span>
          </div>
        </div>

        <div className={'body-table'}>
          {dataHistory.pembelian.isFetch || loading ? (
            <div className={'empty-container'}>
              <ReactLoading
                type={'spin'}
                height={50}
                width={50}
                color={'#159953'}
              />
            </div>
          ) : dataHistory.pembelian.dataPembelian.length ? (
            dataHistory.pembelian.dataPembelian.map((item) =>
              renderItemPending(item),
            )
          ) : (
            renderEmpty()
          )}
        </div>
      </div>

      <ModalPending
        isOpen={isOpenedModalPending}
        currency={userCurrency}
        onToggle={toggleModalPending}
        data={pendingDetailData}
        callback={callback}
      />

      <ModalPaymentConfirmation
        isOpen={isModalConfirmationOpened}
        onToggle={toggleModalConfirmation}
        paymentInfo={paymentInfo}
        callback={callback}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataHistory: state.dataHistory,
    dataMidtrans: state.dataPayment.midtrans.details,
    dataPayment: state.dataPayment,
    userCurrency: state.dataAuth.userCurrency,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    getMidtransDetail: (invoice: string) =>
      dispatch(doGetMidtransPaymentDetail(invoice)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingTab);
